import { AllSelection, TextSelection } from 'prosemirror-state'
import { type EditorView } from 'prosemirror-view'
import { canSplit } from 'prosemirror-transform'
import { schema } from 'prose-core'
import { ourUuid } from 'utils'
import { toggleStateStore } from '../nodeViews/ToggleList/store'

export const turnIntoToggleList = (editorView: EditorView) => () => {
  const {
    state: {
      selection,
      selection: { $from, $to },
      tr,
    },
  } = editorView

  // NOTE: 1. determine the hole we need to cut into the selected content
  // NOTE: the ternary is for all selections
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line no-nested-ternary
  let $cutFrom = tr.doc.resolve(selection instanceof AllSelection ? 0 : $from.depth > 0 ? $from.before() : $from.pos)
  if ($cutFrom.depth > 0 && $cutFrom.node().type === schema.nodes.list_item) {
    if (canSplit(tr.doc, $cutFrom.before())) tr.split($cutFrom.before())
    else if ($cutFrom.node(-1).firstChild === $cutFrom.node()) $cutFrom = tr.doc.resolve($cutFrom.before(-1))
  }

  let $cutTo = tr.doc.resolve(
    // TODO: Fix this the next time the file is edited.
    // eslint-disable-next-line no-nested-ternary
    selection instanceof AllSelection ? tr.doc.nodeSize - 2 : $to.depth > 0 ? tr.mapping.map($to.after()) : $to.pos,
  )
  if ($cutTo.depth > 0 && $cutTo.node().type === schema.nodes.list_item && canSplit(tr.doc, $cutTo.after())) {
    tr.split($cutTo.after())
    $cutTo = tr.doc.resolve($cutTo.pos + 2)
  }

  // NOTE: 2. build the toggle block, using the first child in the selection as summary if possible
  const content = tr.doc.slice($cutFrom.pos, $cutTo.pos)
  const firstContentChildFitsSummary =
    content.content.firstChild &&
    !!schema.nodes.summary.create({}).contentMatchAt(0).matchType(content.content.firstChild.type)

  const blockId = ourUuid()
  tr.replaceWith(
    $cutFrom.pos,
    $cutTo.pos,
    // TODO: Fix this the next time the file is edited.
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    schema.nodes.toggle_list.createAndFill({ blockId }, [
      firstContentChildFitsSummary
        ? // TODO: Fix this the next time the file is edited.
          // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
          schema.nodes.summary.create({}, [content.content.firstChild!])
        : // TODO: Fix this the next time the file is edited.
          // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
          schema.nodes.summary.createAndFill({})!,
      ...(firstContentChildFitsSummary ? content.content.content.slice(1) : content.content.content),
    ])!,
  )
  toggleStateStore.setState(blockId, false)

  const contentSpansIntoDetails = content.content.childCount > 1

  tr.setSelection(
    TextSelection.create(
      tr.doc,
      $cutFrom.pos + (firstContentChildFitsSummary ? 2 : 5) + ($from.pos - $cutFrom.pos),
      $cutFrom.pos +
        (firstContentChildFitsSummary ? 2 : 5) +
        ($to.pos - $cutFrom.pos) +
        (contentSpansIntoDetails ? 1 : 0),
    ),
  )

  editorView.dispatch(tr)
  editorView.focus()
}
